import React from 'react';
import 'twin.macro';
import { useProgrammationsTrash } from '@teetsh/app/src/containers/UserSettings/Trash/Programmations/useProgrammationsTrash';
import { useRestoreProgrammation } from '@teetsh/app/src/containers/UserSettings/Trash/Programmations/useRestoreProgrammation';
import { RestorableList } from '@teetsh/app/src/containers/UserSettings/Trash/components/RestorableList';
import { RestorableProgrammation } from '@teetsh/app/src/types/programmations';
import { useTranslation } from 'react-i18next';

function Details({ view, cycle }: RestorableProgrammation) {
  const { t } = useTranslation(['programmation']);

  return (
    <div tw="text-right font-light capitalize">
      <div>
        {view === 'periode'
          ? t('programmation:onboarding.programmation')
          : t('programmation:onboarding.progression')}
      </div>
      <div>{cycle}</div>
    </div>
  );
}

export function ProgrammationsRestorableList() {
  const { data = [] } = useProgrammationsTrash();
  const restore = useRestoreProgrammation();

  return (
    <RestorableList<RestorableProgrammation>
      items={data}
      restore={restore}
      cardFileDetails={Details}
      tableFileDetails={({ row }) => Details(row.original)}
    />
  );
}
